// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".chunk." + "24216e159a67a13a3ad4" + ".css";
};